












import { get } from 'lodash';
import Chart from './Chart';
import 'echarts/lib/chart/bar';
import { SeriesItemProp } from './Visualization';
import { MetricOptions } from '@/constants/DashboardConstants';
import { getDimensionAxisLabel } from '@/utils/DashboardUtils';

export default {
  name: 'HorizontalBarChart',
  components: {
    Chart,
  },
  props: {
    series: {
      type: Array as SeriesItemProp[],
      default: [],
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    options() {
      const {
        series,
        settings: { metric },
      } = this;

      const { labels, values } = series.reduce(
        (data, item) => {
          const { label, labelId, value, color } = item;
          data.labels.push(label);
          data.values.push({
            value,
            labelId,
            itemStyle: { color },
          });

          return data;
        },
        { labels: [], values: [] }
      );

      const metricLabel = get(MetricOptions, `${metric}.label`);
      const dimensionLabel = getDimensionAxisLabel(this.settings);

      return {
        grid: {
          show: false,
          left: 40,
          top: 20,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'value',
          name: `Count of ${metricLabel}`,
          nameLocation: 'middle',
          nameGap: 30,
          minInterval: 1,
          nameTextStyle: {
            color: '#8c9ba5',
            fontSize: 14,
          },
        },
        yAxis: {
          axisLabel: {
            show: false,
          },
          type: 'category',
          data: labels,
          name: dimensionLabel,
          nameLocation: 'middle',
          nameGap: 20,
          nameTextStyle: {
            color: '#8c9ba5',
            fontSize: 14,
          },
        },
        series: [
          {
            label: {
              normal: {
                show: true,
                position: 'insideLeft',
                verticalAlign: 'middle',
                align: 'left',
                distance: 20,
                formatter: '{b}',
              },
            },
            type: 'bar',
            data: values,
          },
        ],
      };
    },
  },
};
